// Printer status
export const PRINTER_OK = 100
export const PRINTER_ERROR = 200

// Receipt status
export const RECEIPT_UNKOWNERROR = -1
export const RECEIPT_SUCCESS = 100
export const RECEIPT_PRINT_FAILED = 200
export const RECEIPT_BLACKBOX_FAILED = 300
export const RECEIPT_EMPTY = 400;
export const FISCAL_RECEIPT_PRINT_FAILED = 500;



// WEBPACK FOOTER //
// src/constants/Status.js